const schoolShifts = {
  form: {
    general: {
      header: 'Geral',
      fields: {
        students: {
          label: 'Selecionar alunos',
        },
      },
    },
    details: {
      header: 'Detalhes',
      fields: {
        direction: {
          label: 'Direção',
        },
        shift: {
          label: 'Horário letivo',
        },
        from: 'De',
        to: 'Para',
        fromDate: {
          label: 'A partir da Data',
        },
        toDate: {
          label: 'Até à data',
        },
        weekDays: 'Dias úteis',
        fromHour: {
          label: 'As Escolas Começam às',
        },
        reqPick: {
          label: 'Horário de embarque solicitado',
        },
        toHour: {
          label: 'As aulas terminam às',
        },
      },
    },
  },
  select: 'Selecione',
  direction: {
    collect: {
      templates: {
        default: 'A recolher',
        schoolShuttles: 'Para a Escola',
        trailers: 'Recolher',
      },
    },
    distribute: {
      templates: {
        default: 'Distribuir',
        schoolShuttles: 'Da escola',
        trailers: 'Distribuir',
      },
    },
    collectAndDistribute: {
      templates: {
        default: 'Coletar/Distribuir',
        schoolShuttles: 'Para a Escola / Da Escola',
        trailers: 'Coletar/Distribuir',
      },
    },
  },
};

export default schoolShifts;
